module.exports = __webpack_public_path__ + "static/sport/title.8283b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/title.png
// module id = 6p9Q
// module chunks = 0